'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { CustomLink } from '@/app/_components/CustomLink';
import { ReviewDetailContent } from '@/app/donation/gifts/[productNumber]/_components/ReviewDetailContent';
import { DONATION_ROUTES } from '@/constants';
interface ReviewPopupContentProps {
  reviewId: number;
  productNumber: string;
}
export const ReviewPopupContent = t0 => {
  const $ = _c(9);
  const {
    reviewId,
    productNumber
  } = t0;
  let t1;
  if ($[0] !== reviewId) {
    t1 = <ReviewDetailContent reviewId={reviewId} />;
    $[0] = reviewId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== productNumber) {
    t2 = DONATION_ROUTES.GIFTS_DETAIL.pathname({
      productNumber
    });
    $[2] = productNumber;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <div className="mobile-tablet:px-20 mobile-tablet:pb-20"><Button asChild={true} dimensions="H48" className="w-full"><CustomLink prefetch={false} href={t2}>이 답례품 보기</CustomLink></Button></div>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t3) {
    t4 = <div className="flex flex-col gap-20 mobile-tablet:gap-0">{t1}{t3}</div>;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};